<template>
  <v-container grid-list-md>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/">My Arlington</router-link><router-link to="/polling"> — Polling Place Locator</router-link></h2><br/>
            <div id="blurb">
              <p>
                 Enter address to find voting location.
              </p>
            </div>
        </div>
        <v-flex class="layer-page">
        </v-flex>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <button type="button" class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu" :aria-expanded="mobileMenu ? 'true' : 'false'" aria-controls="filters-and-settings">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-minus"></use></svg>
                </button>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <button type="button" class="filter-header" @click="filtersToggle" v-show="!isMobile" :aria-expanded="filtersExpanded ? 'true' : 'false'" aria-controls="filters-and-settings">
                            <span>Filters
                                <svg v-show="filtersExpanded" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!filtersExpanded" style="float: right" class="icon" aria-hidden="true" focusable="false"><use xlink:href="#icon-plus"></use></svg>
                                <span style="clear: both; display: block"></span>
                            </span>
                        </button>
                    </div>

                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete id="addressSearch" ref="autocomplete" @place_changed="placeChanged" placeholder="Enter street address"></gmap-autocomplete>
                    </div>

                    <div class="filter-container zoom-container" v-if="voterPrecinctSelected">
                      <h3>
                        <template v-if="voterPrecinctSelected.PREC_NAME || voterPrecinctSelected.POLLING_PLACE">{{ voterPrecinctSelected.PREC_NAME }}<span v-if="voterPrecinctSelected.PREC_NAME && voterPrecinctSelected.POLLING_PLACE"> - </span>{{ voterPrecinctSelected.POLLING_PLACE }}</template>
                        <template v-else>Polling place</template>
                      </h3>
                      <p>{{voterPrecinctSelected.ADDRESS}}</p>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window">
                <div style="position: relative; top: 0">
                  <div class="toggle-bar" role="group" aria-label="Map or list">
                    <button type="button" class="toggle-link active" :aria-pressed="showMap === true" @click="showMap = true">Map</button>
                  </div>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    id="vue-map-container"
                    aria-label="Map of polling place for your address"
                    >
                    <!-- Location Markers -->
                    <gmap-marker v-if="selectedCoordinates && !selectedCoordinates.fac" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <gmap-polygon v-if="voterPrecinctSelected" :path="voterPrecinctSelected.paths" :options="locationOptions" @click="(e) => infoClick(voterPrecinctSelected, e)"></gmap-polygon>

                    <GmapCircle v-if="selectedCoordinates && radiusSelected" :center="selectedCoordinates" :radius="radiusSelected*1609" :visible="true" :options="{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}"></GmapCircle>

                    <gmap-info-window
                      :opened="selectedInfoWindowPosition !== null"
                      :position="selectedInfoWindowPosition"
                      @closeclick="infoWindowCloseClick">
                        <h3 class="info-window-header"><b v-if="selectedItem.PREC_NAME || selectedItem.POLLING_PLACE">{{ selectedItem.PREC_NAME }}<span v-if="selectedItem.PREC_NAME && selectedItem.POLLING_PLACE"> - </span>{{ selectedItem.POLLING_PLACE }}</b><b v-else>Polling place</b></h3>
                        <div class="info-window-body">
                            {{selectedItem.ADDRESS}}
                          </div>
                    </gmap-info-window>
                </gmap-map>
            </div>
        </div>
    </div>
  </v-container>
</template>

<script>
import * as geolib from 'geolib';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapGetters } from 'vuex';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places,geocode'
  }
})

export default {
  name: 'pollingPlaces',
  components: {
  },
  data () {
    return {
      alert: true,
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      filterQuery: {},
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 } // eslint-disable-line no-undef
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: [],
      pollingPolygon: '',
      voterPrecincts: [],
      voterPrecinctSelected: ''
    }
  },
  computed: {
    ...mapGetters(['']),
    zoomLevel: function () {
      if (!this.selectedCoordinates && (!this.voterPrecinctSelected)) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }
      if (this.voterPrecinctSelected) {
        const voteCenter = geolib.getCenter(this.voterPrecinctSelected.paths);
        voteCenter.lat = Number(voteCenter.latitude);
        voteCenter.lng = Number(voteCenter.longitude);

        return voteCenter;
      }
      return this.center;
    }
  },
  beforeMount: function () {
  },
  mounted: async function () {
    this.isMobile = window.innerWidth < 600;
    await this.getVoterPrecincts();
  },
  watch: {
  },
  methods: {
    async getVoterPrecincts () {
      /* Map colors */
      var items = [];

      var url = 'https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Voter_Precinct_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson';

      let response = await fetch(url).then(response => response.json());
      var columnHeaders = Object.keys(response.features[0].properties);
      items.length = 0;

      response.features.forEach(function (voterPrecinct) {
        var item = {...voterPrecinct};
        for (var i = 0; i < columnHeaders.length; i++) {
          var propertyName = columnHeaders[i];
          var propertyValue = voterPrecinct.properties[propertyName];
          item[propertyName] = propertyValue;
        }

        item.coordinates = voterPrecinct.geometry.coordinates[0];
        // Setup google map polygon
        item.paths = [];
        item.coordinates.forEach(coord => {
          var latLng = {
            lng: Number(coord[0]),
            lat: Number(coord[1])
          }
          item.paths.push(latLng);
        })
        item.popupInfo = item.PREC_NAME;

        var options = {};
        options.strokeColor = voterPrecinct.Color;
        options.strokeOpacity = 0.8;
        options.strokeWeight = 2;
        options.fillColor = voterPrecinct.Color;
        options.fillOpacity = 0.60;

        item.options = options;
        items.push(item);
      });
      this.voterPrecincts = items.sort((a, b) => a.PREC_NAME.localeCompare(b.PREC_NAME));
    },

    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },

    placeChanged: function (place) {
      this.getPrecinct(place.geometry.location.lat(), place.geometry.location.lng());
    },
    getPrecinct: function (lat, lng) {
      this.voterPrecincts.forEach(async precinct => {
        const transformedPoints = precinct.paths.map(({ lat, lng }) => ({ latitude: lat, longitude: lng }));
        console.log(precinct)
        if (geolib.isPointInside({ latitude: lat, longitude: lng }, transformedPoints)) {
          let coord = await this.getPollingPlaceCoordinates(precinct.ADDRESS);
          this.setPollingLocation(coord.lat, coord.lng)
          this.voterPrecinctSelected = precinct;
        }
      })
    },
    getPollingPlaceCoordinates: async function (address) {
      address += 'Arlington, Virginia'
      let latlng = {};
      await fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U')
        .then(response => response.json())
        .then(data => {
          latlng.lat = data.results[0].geometry.location.lat;
          latlng.lng = data.results[0].geometry.location.lng;
        })
      return latlng;
    },
    setPollingLocation: function (lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    infoClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    }
  }
}

</script>

<style lang="scss" scoped>
    .filter-category {
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

.operations-list {
  li {
    font-size: 1em;
    padding: 0px;
  }
}

.h3-list {
  margin: 0px;
}

.column {
  float: left;
  width: 50%;
  min-width: 145px;
  min-height: 55px;
}

.info-window-header {
  margin: 0px;
}

.info-window-body {
  clear: both;
  font-size: 14px;
  padding-top:10px;
}

.header-column-left {
  float: left;
  width: 75%;
  min-height: 30px;
}

.header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 30px;
  margin-bottom: 3px;
  height: auto;
  span {
    font-size: 20px;
  }
}

.list-header-column-left {
  float: left;
  width: 75%;
  min-height: 25px;
}

.list-header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 25px;
  margin-bottom: 1px;
  height: auto;
  span {
    font-size: 20px;
    margin-top: 6px;
  }
}

.row:after {
  display: table;
  clear: both;
}

.transit-row {
  font-size: 20px;
}

.filter-item-nested {
  margin-left: 10px;
}

.wifi-icon-outdoor {
  color: #5ab155;
}

#dr-alert  {
  padding: 9px 16px;
  min-height: 35px;
  background-color: #e38410;
  border: 0px;
  width: 100%;
}

.error {
  background-color: #e38410 !important;
}

@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// polling.vue?6707aeba